// 壳启动时拉一次 bootstrap_state，写进 store。
// /welcome 页面和桌面内的初始化相关入口都会复用这份状态。
import { useEffect } from 'react';
import { readBootstrapState } from './api';
import { useBootstrapStore } from '../store/bootstrapStore';

export function useBootstrapGate(): void {
  const setState = useBootstrapStore((s) => s.setState);
  const setError = useBootstrapStore((s) => s.setError);

  useEffect(() => {
    let cancelled = false;
    readBootstrapState()
      .then((body) => {
        if (cancelled) return;
        setState(body);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const message =
          err instanceof Error ? err.message : '读取初始化状态失败';
        setError(message);
      });
    return () => {
      cancelled = true;
    };
  }, [setState, setError]);
}

// 手动触发重拉（welcome 向导 finalize 成功后要刷新本地状态）。
export async function refreshBootstrapState(): Promise<void> {
  try {
    const body = await readBootstrapState();
    useBootstrapStore.getState().setState(body);
  } catch (err) {
    const message = err instanceof Error ? err.message : '读取初始化状态失败';
    useBootstrapStore.getState().setError(message);
  }
}
